import { render, staticRenderFns } from "./ModelManufactureYearMaintain.vue?vue&type=template&id=59ae79b2"
import script from "./ModelManufactureYearMaintain.vue?vue&type=script&lang=js"
export * from "./ModelManufactureYearMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports